namespace('hrd.charts');